import { KnownUserDtoUserType } from '@groundfloor-platform/mgmt-service-g-sdk';
import { useQueryGetProject } from '../../../../core/queries/projects.queries';
import { mapProjectTypeToUserType } from '../../users.constants';

export type UserAddress = {
  line1: string;
  line2: string;
  country: string;
};

export function useUserAddress(projectID?: string, groupName?: string): UserAddress {
  const project = useQueryGetProject(projectID);

  if (!project.data) {
    return {
      line1: '',
      line2: '',
      country: ''
    };
  }

  const userType = mapProjectTypeToUserType(project.data.projectType);

  const addressUnit = userType === KnownUserDtoUserType.Occupant ? groupName : undefined;

  const projectAddress = project.data.address;

  if (!projectAddress) {
    return {
      line1: addressUnit ?? '',
      line2: '',
      country: ''
    };
  }

  const { line1, line2, suburb, state, postcode, country } = projectAddress;

  // eslint-disable-next-line prettier/prettier
  const addressLine1 = `${addressUnit ? addressUnit + ' / ' : ''}${line1 ? line1 + ', ' : ''}${
    line2 ? line2 + ',' : ''
  }`;
  const addressLine2 = `${suburb ? suburb + ' ' : ''}${state ? state + ' ' : ''}${postcode || ''}`;

  return {
    line1: addressLine1,
    line2: addressLine2,
    country: country ?? ''
  };
}
